
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineComingFrom as ObiGenericLineComingFromElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-coming-from.js';
 
 
 

 
 export const ObiGenericLineComingFrom = createComponent({
   react: React,
   tagName: 'obi-generic-line-coming-from',
   elementClass: ObiGenericLineComingFromElement,
   events: {
     
   }
  });
 
 